module.exports = __webpack_public_path__ + "static/media/curve-two-light-orange.a54426a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-Images/curve-two-light-orange.png
// module id = 127
// module chunks = 0